import getPrimaryNavigationHeight from './getPrimaryNavigationHeight';

const scrollToElementById = (scrollToId: string) => {
  const section = document.getElementById(scrollToId);
  const stickyTopHeader = document.querySelector('#sticky-top-header');
  const stickyArticleHeader = document.querySelector('#sticky-article-header');
  if (section && stickyTopHeader) {
    const sectionPosition = section.getBoundingClientRect().top;
    const stickyHeaderHeight = stickyTopHeader.clientHeight;
    let truePosition =
      sectionPosition +
      window.pageYOffset -
      getPrimaryNavigationHeight() -
      stickyHeaderHeight;
    if (stickyArticleHeader) {
      truePosition = truePosition - stickyArticleHeader.clientHeight;
    }
    window.scrollTo({ top: truePosition, behavior: 'smooth' });
  }
};

export default scrollToElementById;
